import {
    createPinia,
    PiniaPluginContext
} from 'pinia';

const pinia = createPinia();

function piniaCommonPlugins(context: PiniaPluginContext) {
    const { store } = context;
    store.$loading = store.$loading || {};
    store.$error = store.$error || {};
    store.$onAction(({ name, after, onError }) => {
        store.$loading[name] = true;
        store.$error[name] = null;
        after(() => {
            store.$loading[name] = false;
        });
        onError((error) => {
            store.$loading[name] = false;
            store.$error[name] = error;
        });
    });
}


pinia.use(piniaCommonPlugins);

export { pinia };
